import React from "react";
import { string, func, oneOf, array } from "prop-types";

import { RadioButton } from "../../atoms/radio-button";
import Button from "../../atoms/Button";
import "./communication-preferences.m.css";
import { COMMUNICATION_PREFERENCES_COMPONENT_CONTENT } from "../../../constants";

export const CommunicationPreferences = ({
  preferences,
  selectedPreference,
  onPreferenceChange,
  onSave,
  className = "",
  ...props
}) => {
  const handlePreferenceChange = (e) => {
    const newPreference = e.target.value;
    if (onPreferenceChange) {
      onPreferenceChange(newPreference);
    }
  };

  const handleSave = () => {
    if (onSave) {
      onSave(selectedPreference);
    }
  };

  return (
    <div styleName="preferences-section" className={className} {...props}>
      <div styleName="section-header">
        <h2 styleName="section-title">{COMMUNICATION_PREFERENCES_COMPONENT_CONTENT.SECTION_TITLE}</h2>
      </div>

      <div styleName="preferences-content">
        <p styleName="description">
          {COMMUNICATION_PREFERENCES_COMPONENT_CONTENT.DESCRIPTION}
        </p>

        <div styleName="options">
          {preferences.map((option) => (
            <label key={option.value} styleName="preference-option">
              <RadioButton
                name="communication-preference"
                value={option.value}
                checked={selectedPreference === option.value}
                onChange={handlePreferenceChange}
                styleName="radio"
              />
              <div styleName="option-details">
                <span styleName="option-label">{option.label}</span>
              </div>
            </label>
          ))}
        </div>

        <Button
          variant="dark"
          onClick={handleSave}
          styleName="save-button"
        >
          {COMMUNICATION_PREFERENCES_COMPONENT_CONTENT.SAVE_BUTTON}
        </Button>
      </div>
    </div>
  );
};

CommunicationPreferences.propTypes = {
  preferences: array.isRequired,
  selectedPreference: oneOf(["immediate", "weekly", "fortnightly", "monthly"]),
  onPreferenceChange: func,
  onSave: func,
  className: string
};